export enum PromiseDepartment {	
	General = 0,
	Transport = 10
}